import { call, put, takeLatest } from 'redux-saga/effects';
import {
    PEM_AVERAGE_CLAIMS_DATA_REQUEST,
    PEM_AVG_CLAIM_TAT_TREND_DATA_REQUEST,
    PEM_CONRACT_YIELD_DATA_REQUEST,
    PEM_EFFORT_INDEX_DATA_REQUEST,
    PEM_SERVICE_METRIC_DATA_REQUEST,
    PEM_SERVICE_METRIC_DATA_REQUEST_APPEAL,
    PEM_SERVICE_METRIC_DATA_REQUEST_DiGITAL,
    PEM_SERVICE_METRIC_DATA_REQUEST_SECRET
} from '@src/middleware/actions/actionTypes';
import { setRequestError, setRequestLoading, setRequestSuccess } from '@src/middleware/actions/common/common.actions';
import { providerExperienceStateKeys } from '@src/CommonComponents/constant/constant';
import { getClaimsData, getEffortIndexData, getEffortIndexSummaryData, getServiceMetricData, getClaimsYieldData, getAvgClaimTatTrendData } from '@src/middleware/services/PEM/pem-details.service';

const pemInFlightRequestSignatures = new Set<string>();

const getServiceMethod :any= (key: string) => {
  switch (key) {
    case providerExperienceStateKeys.averageClaimsData:
      return getClaimsData;
    case providerExperienceStateKeys.effortIndexData:
      return getEffortIndexData;
    case providerExperienceStateKeys.effortIndexSummaryData:
      return getEffortIndexSummaryData;
    case providerExperienceStateKeys.contractYieldData:
      return getClaimsYieldData;
      case providerExperienceStateKeys.serviceMetricsPost:
        return getServiceMetricData;
        case providerExperienceStateKeys.serviceMetricsAppeal:
        return getServiceMetricData;
        case providerExperienceStateKeys.serviceMetricsDigital:
        return getServiceMetricData;
        case providerExperienceStateKeys.serviceMetricsSecret:
        return getServiceMetricData;
      case providerExperienceStateKeys.avgClaimTatTrendData:
        return getAvgClaimTatTrendData;
    default:
      return getClaimsData;
  }
}
export function* fetchProviderExperienceData(action: any) {
  const { key, payload } = action;
  const loadingKey = `${key}Loading`;
  const errorKey = `${key}Error`;
  const requestSignature = `${key}:${JSON.stringify(payload || {})}`;

  // Prevent duplicate in-flight calls for the exact same card payload.
  if (pemInFlightRequestSignatures.has(requestSignature)) {
    return;
  }

  pemInFlightRequestSignatures.add(requestSignature);

  try {
    yield put(setRequestError(false, errorKey));
    yield put(setRequestLoading(true, loadingKey));

    const response = yield call(getServiceMethod(key), payload);


    yield put(setRequestLoading(false, loadingKey));

    if (response?.status === false) {
      yield put(setRequestError(true, errorKey));
    } else {
      yield put(setRequestSuccess(response?.Data, key));
    }
  } catch (error) {
    yield put(setRequestLoading(false, loadingKey));
    yield put(setRequestError(true, errorKey));
  } finally {
    pemInFlightRequestSignatures.delete(requestSignature);
  }
}


export function* pemDetailsSaga() {
  yield takeLatest(PEM_AVERAGE_CLAIMS_DATA_REQUEST, fetchProviderExperienceData);
  yield takeLatest(
    (action: any) => action.type === PEM_EFFORT_INDEX_DATA_REQUEST
      && action.key === providerExperienceStateKeys.effortIndexData,
    fetchProviderExperienceData
  );
  yield takeLatest(
    (action: any) => action.type === PEM_EFFORT_INDEX_DATA_REQUEST
      && action.key === providerExperienceStateKeys.effortIndexSummaryData,
    fetchProviderExperienceData
  );
  yield takeLatest(PEM_CONRACT_YIELD_DATA_REQUEST, fetchProviderExperienceData);
  yield takeLatest(PEM_SERVICE_METRIC_DATA_REQUEST, fetchProviderExperienceData);
  yield takeLatest(PEM_SERVICE_METRIC_DATA_REQUEST_APPEAL, fetchProviderExperienceData);
  yield takeLatest(PEM_SERVICE_METRIC_DATA_REQUEST_DiGITAL, fetchProviderExperienceData);
  yield takeLatest(PEM_SERVICE_METRIC_DATA_REQUEST_SECRET, fetchProviderExperienceData);
  yield takeLatest(PEM_AVG_CLAIM_TAT_TREND_DATA_REQUEST, fetchProviderExperienceData);
}

export default [pemDetailsSaga];
